import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

const INTERACTION_DELAY = 250;

export default class extends Controller {
  initialize() {
    this.ro = new ResizeObserver(entries => {
      this.observerResize();
    });
    this.ro.observe(this.element.parentNode);
  }

  resize() {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(this.resizeEnd.bind(this), INTERACTION_DELAY);
  }

  resizeEnd() { // eslint-disable-line class-methods-use-this
    Rails.fire(window, 'resize-end');
  }

  observerResize() {
    window.clearTimeout(this.observerResizeTimer);
    this.observerResizeTimer = window.setTimeout(this.observerResizeEnd.bind(this), INTERACTION_DELAY);
  }

  observerResizeEnd() { // eslint-disable-line class-methods-use-this
    Rails.fire(this.element, 'observer-resize-end');
  }
}
